<template>
  <component :is="size" :class="classes">
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'h1',
      validator: (value) => {
        return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(value)
      }
    },
    color: {
      type: String,
      default: 'white',
      validator: (value) => {
        return ['white', 'orange', 'black', 'dark-orange', 'purple-pink'].includes(value)
      }
    },
    isUppercase: {
      type: Boolean,
      default: false
    },
    letterSpacing: {
      type: String,
      default: 'normal',
      validator: (value) => {
        return ['normal', '4'].includes(value)
      }
    }
  },

  computed: {
    classes () {
      return [
        'commonHeading',
        `commonHeading_${this.size ? this.size : 'h1'}`,
        `commonHeading_${this.color ? this.color : 'white'}`,
        `commonHeading_letter-spacing-${this.letterSpacing ? this.letterSpacing : 'normal'}`,
        {
          commonHeading_uppercase: this.isUppercase
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.commonHeading {
  font-weight: 700;
  margin: 0;

  &_h1 {
    font-size: 40px;
    line-height: 48px;
  }

  &_h2 {
    font-size: 32px;
    line-height: 38px;
  }

  &_h3 {
    font-size: 28px;
    line-height: 34px;
  }

  &_h4 {
    font-size: 24px;
    line-height: 28px;
  }

  &_h5 {
    font-size: 20px;
    line-height: 24px;
  }

  &_h6 {
    font-size: 16px;
    line-height: 20px;
  }

  &_white {
    color: #fff;
  }

  &_black {
    color: #2d2d2d;
  }

  &_orange {
    background: linear-gradient(130.92deg, #f8b700 -0.63%, #f87900 58%, #ae35dd 114.33%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &_dark-orange {
    background: linear-gradient(130.92deg, #f87900 -0.63%, #fe4f45 58%, #e419ba 114.33%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &_purple-pink {
    background: linear-gradient(90deg, #c27aff 0%, #dab2ff 50%, #fb64b6 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &_letter-spacing-normal {
    letter-spacing: normal;
  }

  &_letter-spacing-4 {
    letter-spacing: 4px;
  }

  &_uppercase {
    text-transform: uppercase;
  }
}
</style>
